"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HazmatInformationComment = exports.HazmatInformationStatus = exports.HazmatPackagingType = exports.UnId = void 0;
var UnId;
(function (UnId) {
    UnId["UN3481"] = "UN3481";
    UnId["UN3481_SI"] = "UN3481_SI";
    UnId["UN3091"] = "UN3091";
    UnId["UN3091_SI"] = "UN3091_SI";
    UnId["UN3480"] = "UN3480";
    UnId["UN3480_SI"] = "UN3480_SI";
    UnId["UN3090"] = "UN3090";
    UnId["UN3090_SI"] = "UN3090_SI";
    UnId["LQ"] = "LQ";
    UnId["LQ_Class3"] = "LQ_Class3";
    UnId["LQ_Class2_2"] = "LQ_Class2_2";
    UnId["ORMD"] = "ORMD";
})(UnId = exports.UnId || (exports.UnId = {}));
var HazmatPackagingType;
(function (HazmatPackagingType) {
    HazmatPackagingType["GLASS"] = "GLASS";
    HazmatPackagingType["NON_GLASS"] = "NON_GLASS";
    HazmatPackagingType["METAL_AEROSOLS"] = "METAL_AEROSOLS";
    HazmatPackagingType["OTHER"] = "OTHER";
})(HazmatPackagingType = exports.HazmatPackagingType || (exports.HazmatPackagingType = {}));
var HazmatInformationStatus;
(function (HazmatInformationStatus) {
    HazmatInformationStatus["INCOMPLETE"] = "INCOMPLETE";
    HazmatInformationStatus["PENDING"] = "PENDING";
    HazmatInformationStatus["APPROVED"] = "APPROVED";
    HazmatInformationStatus["REJECTED"] = "REJECTED";
})(HazmatInformationStatus = exports.HazmatInformationStatus || (exports.HazmatInformationStatus = {}));
var HazmatInformationComment;
(function (HazmatInformationComment) {
    HazmatInformationComment["CANNOT_SHIP_BY_AIR"] = "This item cannot be shipped by air.";
    HazmatInformationComment["OTHER"] = "Please contact Flexport support.";
    HazmatInformationComment["REQUIRES_REFRIGERATION"] = "This item requires refrigeration.";
    HazmatInformationComment["SDS_EXPIRED"] = "SDS expired.";
    HazmatInformationComment["SPECIAL_HANDLING_PROTECTION"] = "This item requires special handling protection.";
    HazmatInformationComment["UNSUPPORTED_UN_ID"] = "Unsupported UN ID. This item is not an allowable hazmat item.";
})(HazmatInformationComment = exports.HazmatInformationComment || (exports.HazmatInformationComment = {}));
//# sourceMappingURL=HazmatInformation.js.map